export default __webpack_public_path__ + "static/media/logo.617418df.svg";